import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_i-move",
  "use": "svg_i-move-usage",
  "viewBox": "0 0 18 10",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 10\" id=\"svg_i-move\"><rect width=\"18\" height=\"2\" rx=\"1\" fill=\"currentColor\" /><rect y=\"4\" width=\"18\" height=\"2\" rx=\"1\" fill=\"currentColor\" /><rect y=\"8\" width=\"18\" height=\"2\" rx=\"1\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol